<script setup lang="ts">
import SePopup from '@/src/ui-kit/popup/Popup.vue';
import SeButton from '@/src/ui-kit/button/Button.vue';
import SeLink from '@/src/components/Link.vue';
import { theme } from '@/theme';
import { storeToRefs } from 'pinia';
import { usersStore } from '@/src/store/users';
import { ref } from 'vue';
import { useStorage } from '@/src/composables/useStorage';

const { siteName } = theme.general;
const { isAuthenticated, isAdvisor } = storeToRefs(usersStore());
const { getStorageValue, setCookie } = useStorage();

const userClosedPopup = ref(false);
userClosedPopup.value = getStorageValue('closeDownNotificationPopupHidden') == 'true';

const closePopup = () => {
  userClosedPopup.value = true;
  setCookie('closeDownNotificationPopupHidden', 'true');
};
</script>

<script lang="ts">
export default {
  name: 'SeCloseDownPopup',
};
</script>

<template>
  <se-popup
    v-if="!userClosedPopup && !theme.general.siteActive"
    show-close
    :title="'📢 ' + siteName + ' is Closed!'"
    header-divider
    @close="closePopup"
  >
    <div class="flex flex-col gap-16 my-24">
      <h1 class="font-bold">🔒 We’ve Closed This Platform</h1>
      <p>{{ siteName }} is now closed for live chat, inbox, and top-ups.</p>
      <p>You can still {{ isAuthenticated ? '' : 'log in here to' }} <b>download your past sessions</b>.</p>
      <p>
        👉 We’ve moved to
        <se-link href="https://www.seeer.com" class="font-bold !underline text-primary-100">Seeer.com </se-link>
        {{ isAdvisor ? '' : '— where your favorite advisors are available.' }}
      </p>
      <p>⚠️ <b>Important:</b> Your account was <b>not moved</b> to Seeer.</p>
      <p>
        If you want to continue using our services, please create a new account at
        <se-link href="https://www.seeer.com" class="font-bold !underline text-primary-100">Seeer.com </se-link>.
      </p>
    </div>
    <template #footer>
      <div class="w-full flex justify-center">
        <se-link href="https://www.seeer.com">
          <se-button>Go To Seeer.com</se-button>
        </se-link>
      </div>
    </template>
  </se-popup>
</template>

<style scoped lang="scss"></style>
